import script from "./GrAlert.vue?vue&type=script&setup=true&lang=js"
export * from "./GrAlert.vue?vue&type=script&setup=true&lang=js"

import "./GrAlert.vue?vue&type=style&index=0&id=13af335a&lang=scss"

const __exports__ = script;

export default __exports__